<template>
  <v-card
    tile
    class="pt-2 pricing-card-wrapper"
    :class="{ 'mt-5': $vuetify.breakpoint.smAndDown }"
    min-width="250"
    :width="$vuetify.breakpoint.smAndDown ? '80%' : 'auto'"
  >
    <v-card-title class="d-flex flex-column justify-space-between pricing-card-title">
      <div class="card-avatar">
        <v-img
          v-if="$vuetify.breakpoint.mdAndUp"
          height="100%"
          width="100%"
          contain
          :src="require('@/assets/mark-variations/Asset 2.svg')"
          alt="Epic Receptionists Logo"
        />
      </div>
      <!-- <div class="text-caption">{{ details.name }}</div> -->
      <div class="text-h6">{{ details.minutes }}</div>
      <div class="text-subtitle-1" :xclass="{ 'mt-6': !details.callCountEstimate }">
        {{ price }}/{{ details.units }}
      </div>
      <div v-if="details.isPopular" class="ribbon"><span>popular</span></div>
    </v-card-title>
    <v-divider />
    <v-card-text class="card-text">
      <ul>
        <li v-if="details.callCountEstimate">
          About {{ details.callCountEstimate }} calls per month<span class="text-superscript">1</span>
        </li>
        <li v-for="(point, index) in details.points" :key="index">
          {{ point }}
        </li>
      </ul>
    </v-card-text>
  </v-card>
</template>

<script>
import numeral from 'numeral'
export default {
  props: {
    details: {
      type: Object,
      required: true
    },

    billingFrequency: {
      type: Object,
      required: true
    }
  },

  computed: {
    price() {
      const price = this.details.isFixedRate
        ? this.details.cost
        : this.details.cost - this.details.cost * (this.billingFrequency.discount / 100)

      return numeral(price).format('$0,0[.]00')
    }
  }
}
</script>

<style scoped lang="scss">
.pricing-card-wrapper {
  margin-top: 20px;
}
.card-avatar {
  height: 40px;
  width: 40px;
  position: absolute;
  top: -20px;
}
.pricing-card-title {
  height: 95px;
  white-space: nowrap;
}
.card-text {
  height: 140px;
}

.ribbon {
  position: absolute;
  right: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;

  span {
    font-size: 10px;
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
    text-align: center;
    line-height: 20px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    width: 100px;
    display: block;
    background: #79a70a;
    background: linear-gradient(#f79e05 0%, #f79e05 100%);
    box-shadow: 0 1px 10px -5px rgba(0, 0, 0, 1);
    position: absolute;
    top: 19px;
    right: -21px;

    &::before {
      content: '';
      position: absolute;
      left: 0px;
      top: 100%;
      z-index: -1;
      border-left: 3px solid #f79e05;
      border-right: 3px solid transparent;
      border-bottom: 3px solid transparent;
      border-top: 3px solid #f79e05;
    }

    &::after {
      content: '';
      position: absolute;
      right: 0px;
      top: 100%;
      z-index: -1;
      border-left: 3px solid transparent;
      border-right: 3px solid #f79e05;
      border-bottom: 3px solid transparent;
      border-top: 3px solid #f79e05;
    }
  }
}
</style>
